export default __webpack_public_path__ + "static/form-button-feedback-dont-c54d2c1a65cf79e3571146bee012e5b6.png";